import { HeaderAction, HeaderContainer } from './styled';
export function Header(props) {
    const { title, action } = props;
    return (<HeaderContainer>
      {title}
      {action && <HeaderAction>{action}</HeaderAction>}
    </HeaderContainer>);
}
